import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from '@reach/router';
import axios from 'axios';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import Layout from './Layout/Layout';
import PhotoSlider from './Assets/PhotoSlider';

import { ServerImage } from '../../../server/app';

import PhotosStyles from './Photos.styles';

const Photos: React.FC<RouteComponentProps> = () => {
  // Local state
  const [device1Images, setDevice1Images] = useState<ServerImage[]>([]);
  const [device2Images, setDevice2Images] = useState<ServerImage[]>([]);

  const [device1, setDevice1] = useState<ServerImage | undefined>();
  const [device2, setDevice2] = useState<ServerImage | undefined>();

  // Effects
  useEffect(() => {
    const getAvailableImages = async () => {
      const availableImages = await axios.get<ServerImage[]>('/api/images?path=photos');
      const sortedImages = availableImages.data.sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );

      setDevice1Images(sortedImages);
      setDevice2Images(sortedImages);
    };

    getAvailableImages();
  }, []);

  // Render
  return (
    <Layout>
      <PhotosStyles>
        <h2>Photos</h2>

        <div className="selection">
          <p>Select two devices to compare:</p>

          <div className="phones">
            <div className="phone">
              <Autocomplete
                disableClearable
                options={device1Images}
                getOptionLabel={image => image.name}
                onChange={(_e, value) => value && setDevice1(value)}
                renderInput={params => (
                  <TextField {...params} label="Device 1" variant="outlined" />
                )}
              />
            </div>

            <div className="phone">
              <Autocomplete
                disableClearable
                options={device2Images}
                getOptionLabel={image => image.name}
                onChange={(_e, value) => value && setDevice2(value)}
                renderInput={params => (
                  <TextField {...params} label="Device 2" variant="outlined" />
                )}
              />
            </div>
          </div>
        </div>

        {device1 && device2 && (
          <div className="slider">
            <PhotoSlider device1={device1} device2={device2} />
          </div>
        )}
      </PhotosStyles>
    </Layout>
  );
};

export default Photos;
